import script from "./warnDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./warnDetail.vue?vue&type=script&setup=true&lang=js"

import "./warnDetail.vue?vue&type=style&index=0&id=181d7992&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181d7992"]])

export default __exports__